/** Bump when static assets (i18n, env) must invalidate cached clients. */
export const APP_ASSET_VERSION = '2026110301';
